module.exports = __webpack_public_path__ + "img/112.557ae220.png";